export default __webpack_public_path__ + "bc4be2168a00b02b56cad7ab7a370e99.png";